import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { FormFileDropzone } from 'components/input'
import { withForm } from 'decorators/withForm'
import { useClearMatch, useMatchResults, useMatchUpload } from 'hooks/useMatch'

type CampaignTargetsMatchProps = {
  handleSubmit: (...args: any[]) => any
  id: string
  open: boolean
  onClose: (...args: any[]) => any
}

const CampaignTargetsMatch = ({ handleSubmit, id, open, onClose }: CampaignTargetsMatchProps) => {
  const navigate = useNavigate()
  const { data: match } = useMatchResults()
  const upload = useMatchUpload()
  const clearMatch = useClearMatch()

  const onSubmit = async ({ file }: any) => {
    try {
      await upload.mutateAsync({ file })
      navigate(UrlProvider.getUrl('campaign.targets.match', { id }))
    } catch {
      // errors surface via match.errors in the dropzone below
    }
  }

  return (
    <Dialog onClose={onClose} open={open}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Upload CSV file</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} style={{ width: 500 }}>
            <Grid size={{ sm: 12 }}>
              <FormFileDropzone errorId={match.errors.join(', ')} name="file" onChange={() => clearMatch()} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
          <Button color="primary" disabled={upload.isPending} loading={upload.isPending} type="submit">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default withForm({ form: 'targetsMatch' })(CampaignTargetsMatch)
